"use client";

import React from "react";
import { Button, Label } from "semantic-ui-react";

const SaveCityButton = ({ loggedin, isMobile, save, onSaveCity }) => {
  if (!loggedin) return null;

  return save ? (
    <Button
      as="div"
      labelPosition="right"
      floated="right"
      onClick={onSaveCity}
      className="theme_green btn_green"
    >
      <Button icon="check" className="theme_green btn_green" />
      <Label
        as="a"
        content="Saved"
        basic
        pointing="left"
        className="theme_green btn_green"
      />
    </Button>
  ) : (
    <Button
      as="div"
      labelPosition="right"
      floated="right"
      onClick={onSaveCity}
      className="theme_blue btn_blue"
    >
      <Button icon="heart" className="btn_blue_bg" />
      <Label
        as="a"
        name="saveCity"
        content={isMobile ? "Save" : "Save this City"}
        basic
        className="theme_blue btn_blue"
        pointing="left"
      />
    </Button>
  );
};

export default SaveCityButton;
